import React from "react";
import '../../styles/components/card/card2.scss';
import ICard, {iconType} from "../../models/view/common/ICard";
import {FontIcon} from "./FontIcon";

interface ICardProps {
  cardModel: ICard,
  onClick?: () => void;
  showLessonNumbers: boolean;
}

export default function Card2({cardModel, onClick, showLessonNumbers = true}: ICardProps) {
  const lessonNumberElement = showLessonNumbers ? <div className={`lesson-number`}>{cardModel.number}</div> : null;
  const checkMarkEl = cardModel.isComplete ? <div className={`checkmark`}><FontIcon icon={"icon-check"}/> </div> : null;
  let progressClassName = ``;
  if(cardModel.isStarted || cardModel.isUpNext){ progressClassName = `in-progress`; }
  if(cardModel.isComplete){ progressClassName = `complete`; }
  const progressEl = !cardModel.isComplete && cardModel.isStarted ? Progress({percentComplete: cardModel.percentComplete}) : null;
  const inProgressAmountOrUpNextText = cardModel.isUpNext ? `Up next` : cardModel.amountComplete;
  // only mark featured lesson (aka last lesson they visited) with oval.
  const highlightedClassName = cardModel.isHighlighted ? `highlighted-${cardModel.difficultyCategory}` : ``;
  const difficultyClassName = cardModel.difficultyCategory;

  return (
    <div className={`card2 ${difficultyClassName} ${progressClassName}`} onClick={onClick}>
      <div className={`oval ${highlightedClassName}`}>&nbsp;</div>
      <div className={`checkmark-and-lesson-number`}>
        {checkMarkEl}
        {lessonNumberElement}
      </div>
      <img className={`image`} src={cardModel.imageUrl} alt="lesson art"/>
      <div className={`title`}>{cardModel.title}</div>
      <div className={`subtitle`}>{cardModel.subText}</div>
      {createIconElement(cardModel.icon)}
      <div className={`in-progress-amount`}>{inProgressAmountOrUpNextText}</div>
      {progressEl}
    </div>
  );
}

function Progress({percentComplete}:{percentComplete?: number}){
  return (
    <progress className={`progress`} value={percentComplete ? percentComplete : 0} max={100} />
  )
}

function createIconElement(iconType: iconType){
  if (iconType === "video") {
    return <FontIcon icon={"icon-video-tutorial-solid"} ariaLabel={'Includes video'} title={"Includes video"} />
  }
}